import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBBtn,
  MDBBadge,
  MDBCol,
  MDBCardFooter,
  MDBCardUp,
  MDBAvatar,
  MDBIcon,
} from "mdbreact";

import { faStar, faHeart } from "@fortawesome/free-solid-svg-icons";

import LocationMarkerGray from "../../../../assets/images/Icons/Links/Location Marker Gray.svg";
import { useSelector } from "react-redux";
import { Language } from "../../../../redux/store/base/language";

interface PostItemProps {
  Name: string;
  Profile: any;
  Location: string;
  Rating: number;
  Likes: number;
  Cover?: any;
}

const PostItem = (props: PostItemProps) => {
  const state = useSelector(
    (state: { lang: Language }) => state.lang.dictionary
  );
  return (
    <MDBCol md={"4"} sm={"6"} xs={"12"} className="mt-3">
      <MDBCard>
        <MDBCardHeader>
          <img
            src="https://images.axios.com/2DQfAJlAhy-PNB6aA8UvuwZzF0o=/0x96:1800x1109/1920x1080/2019/02/05/1549385245127.jpg"
            alt=""
          />
        </MDBCardHeader>
        <MDBAvatar className="mx-auto white">
          <img
            src="https://portfoliomanager.energystar.gov/images/property/486/48679a102eb9a094d025d2ecf7f6c7fb/approved/460.jpg"
            alt=""
          />
        </MDBAvatar>
        <MDBCardBody>
          <h4 className="card-title">مستشفى بايلور</h4>
          <p className="eval">
            <div className="ratting">
              <FontAwesomeIcon icon={faStar} className="d-inline-inline" />
              <span>{props.Rating}</span>
            </div>
            <div className="like mr-3">
              <FontAwesomeIcon icon={faHeart} className="d-inline-inline" />
              <span>
                {props.Likes} {state?.likes}
              </span>
            </div>
          </p>
          <p className="location">
            <img src={LocationMarkerGray} alt="" />
            {props.Location}
          </p>
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
  );
};

PostItem.prototype = {
  Name: PropTypes.node.isRequired,
  Profile: PropTypes.node.isRequired,
  Location: PropTypes.node.isRequired,
  Rating: PropTypes.node.isRequired,
  Likes: PropTypes.node.isRequired,
  Specializ: PropTypes.node.isRequired,
  PostText: PropTypes.node.isRequired,
};

export default PostItem;
